import { motion } from 'framer-motion'

import { UnitFirmwareModal } from '@apps-common/apps/portal/pages/management/components/unit-firmware'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitFirmwareModel } from '@apps-common/types/management/unit-firmware'

interface IProps {
  firmware: IUnitFirmwareModel
  onChangeCallback: () => void
}
export const UnitFirmwareListCard = ({ firmware, onChangeCallback }: IProps) => {
  const { unitFirmwareId, unitFirmwareVersion, defaultItem } = firmware

  return (
    <motion.div variants={GRID_CARD_VARIANTS} className='w-full p-6 rounded-[35px] bg-surface text-text border border-border'>
      <div className='flex items-center justify-between w-full'>
        <div className='jost-light text-[0.9em]'>{unitFirmwareVersion}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Default item</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{defaultItem ? 'Yes' : 'No'}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={UnitFirmwareModal}
        disabled={false}
        componentProps={{
          unitFirmwareId
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
